var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public_container"},[_c('Head'),_c('div',{staticClass:"mobile_container"},[_vm._v(" 待办 ")]),_c('FooterTabbar',{attrs:{"tabBarList":_vm.tabBarList,"tabBarActive":_vm.tabBarActive}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }